import { HTTP_TOKEN } from "./http";

// ACCOUNTS
export const getAccountsFacebook = (params) => {
  return HTTP_TOKEN.get(
    "integration/external/facebook/list_accounts_ads",
    { params }
  ).then((result) => {
    return result.data;
  });
};

export const getAccountsGoogle = (params) => {
  return HTTP_TOKEN.get("integration/external/google/list_accounts_ads", {
    params,
  }).then((result) => {
    return result.data;
  });
};


// CAMAPIGNS
export const getCampaignsFacebook = (params) => {
  return HTTP_TOKEN.get(
    "integration/external/facebook/list_account_campaigns",
    { params }
  ).then((result) => {
    return result.data;
  });
};

export const getCampaignsGoogle = (params) => {
  return HTTP_TOKEN.get("integration/external/google/list_account_campaigns", {
    params,
  }).then((result) => {
    return result.data;
  });
};

export const getCampaignsUtm = (params) => {
  return HTTP_TOKEN.get("integration/external/utms/list_campaigns", {
    params,
  }).then((result) => {
    return result.data;
  });
};

export const getCampaignsTikTok = (params) => {
  return HTTP_TOKEN.get("integration/external/tiktok/list_account_campaigns", {
    params,
  }).then((result) => {
    return result.data;
  });
};

// ADGROUPS
export const getAdGroupsFacebook = (params) => {
  return HTTP_TOKEN.get(
    "integration/external/facebook/list_account_adgroups",
    { params }
  ).then((result) => {
    return result.data;
  });
};

export const getAdGroupsGoogle = (params) => {
  return HTTP_TOKEN.get("integration/external/google/list_account_adgroups", {
    params,
  }).then((result) => {
    return result.data;
  });
};

// ADS
export const getAdsFacebook = (params) => {
  return HTTP_TOKEN.get(
    "integration/external/facebook/list_account_ads",
    { params }
  ).then((result) => {
    return result.data;
  });
};

export const getAdsGoogle = (params) => {
  return HTTP_TOKEN.get("integration/external/google/list_account_ads", {
    params,
  }).then((result) => {
    return result.data;
  });
};


// UPDATE 

export const updateStatusFBADS = (params) => {
  return HTTP_TOKEN.put("integration/external/facebook/update_status",
  { ...params },
  ).then((result) => {
    return result.data;
  });
};

export const updateBulletFBADS = (params) => {
  return HTTP_TOKEN.put("integration/external/facebook/update_bullet",
  { ...params },
  ).then((result) => {
    return result.data;
  });
};


export const updateStatusGADS = (params) => {
  return HTTP_TOKEN.put("integration/external/google/update_status",
  {... params },
  ).then((result) => {
    return result.data;
  });
};

export const updateBulletGADS = (params) => {
  return HTTP_TOKEN.put("integration/external/google/update_bullet",
  { ...params },
  ).then((result) => {
    return result.data;
  });
};

// generate url AD
export const generateUrlAd = (params) => {
  return HTTP_TOKEN.get("integration/external/facebook/generate_url_ad", {
    params,
  }).then((result) => {
    return result.data;
  });
};


export const duplicateCampaignFBADS = (params) => {
  return HTTP_TOKEN.post("integration/external/facebook/duplicate_campaign", 
  {...params },
  ).then((result) => {
    return result.data;
  });
};
